import { stepsComponents } from '@components/_steps/stepsComponents'
import { Layout } from '@components/Layout'
import { ThanksPage } from '@components/ThanksPage'
import { quiz } from '@constants/data'
import { stepEvents } from '@constants/stepEvents'
import { useFetch } from '@hooks/useFetch'
import { useSteps } from '@hooks/useSteps'
import { getCookie } from '@lib/getCookie'
import { getStageAndScreenByStep } from '@lib/getStageAndScreenByStep'
// import { getStageAndScreenByStep } from '@lib/getStageAndScreenByStep'
import { transformData } from '@lib/transformData'
import { useEffect, useLayoutEffect, useState } from 'react'
import { FormProvider, useForm } from 'react-hook-form'

import s from './Main.module.scss'
import type { MainProps } from './Main.props'

export function Main({ ...props }: MainProps) {
  const isFirstVisit = localStorage.getItem('isFirstVisit') === null

  const { trigger: sendUtmOrForm } = useFetch()
  const { trigger: sendEvent } = useFetch('send_event')

  const [data] = useState<any>(transformData(quiz.data.stages))
  const [availibility] = useState(`${quiz.data.first_availability?.date_display} - ${quiz.data.first_availability?.time_display}`)

  const { stepsHistory, setStepsHistory, currentStep, setCurrentStep } = useSteps()

  const defaultValues = JSON.parse(quiz.data?.client_data?.client_json_data)

  const methods = useForm({
    defaultValues: {
      ...defaultValues,
      time: defaultValues?.time
        ? JSON.stringify(defaultValues.time)
        : null,
      address_detail: defaultValues?.address_detail
        ? JSON.stringify(defaultValues?.address_detail)
        : null,
      name: quiz.data?.client_data?.name || '',
      email: quiz.data?.client_data?.email || '',
      phone: quiz.data?.client_data?.phone || '',
    }
  })

  const backHandler = () => {
    setCurrentStep(stepsHistory.at(-2) || 1)
    setStepsHistory((prev) => prev.slice(0, -1))
  }

  useLayoutEffect(() => {
    const searchParams = new URLSearchParams(window.location.search)
    const pathname = window.location.pathname
    const lastSegment = pathname.split('/').filter(Boolean).at(-1)

    const utm = {
      utm_source: searchParams.get('utm_source') || getCookie('utm_source'),
      utm_campaign: searchParams.get('utm_campaign') || getCookie('utm_campaign'),
      utm_content: searchParams.get('utm_content') || getCookie('utm_content'),
      utm_medium: searchParams.get('utm_medium') || getCookie('utm_medium'),
      utm_term: searchParams.get('utm_term') || getCookie('utm_term'),
      utm_path: searchParams.get('utm_path') || getCookie('utm_path'),
      fbclid: searchParams.get('fbclid') || getCookie('fbclid'),
    }

    const hasUtm = !!Object.values(utm).filter(Boolean).length

    if (hasUtm || isFirstVisit) {
      sendUtmOrForm(hasUtm ? { data: utm } : {})
        .then(() => {
          if (isFirstVisit) {
            sendEvent({ data: { event: stepEvents[currentStep] } })
            localStorage.setItem('isFirstVisit', 'false')
          }
        })
    }

    if (lastSegment === 'quiz') {
      history.pushState(null, '', `${pathname}${pathname.at(-1) !== '/' ? '/' : ''}${quiz.data.client_uuid}`)
    }
  }, [])

  useEffect(() => {
    if (![4, 6].includes(currentStep)) {
      const { stage, screen } = getStageAndScreenByStep(quiz.data.stages as any, currentStep);
      (window as any)?.fbq?.('track', `Quiz_Stage_${stage}_scr_${screen}`)
    }

    if (!isFirstVisit) {
      sendEvent({ data: { event: stepEvents[currentStep] } })
    }

    window.scrollTo({ top: 0, behavior: 'smooth' })

    const handler = (ev: BeforeUnloadEvent) => {
      ev.preventDefault()
    }

    if (currentStep !== 7) {
      window.addEventListener('beforeunload', handler)
    }

    return () => window.removeEventListener('beforeunload', handler)
  }, [currentStep])

  if (!data) {
    return null
  }

  return (
    <main className={s.main}>
      <FormProvider {...methods}>
        {currentStep === 7 ? (
          <ThanksPage
            data={data?.[`screen_${currentStep}_hero_variants`]}
          />
        ) : (
          <Layout
            {...stepsComponents[currentStep]({
              headerData: data?.[`screen_${currentStep}_hero_variants`] || data[`screen_${currentStep}_hero`],
              formData: data[`screen_${currentStep}_questions`]
            })}
            backHandler={backHandler}
            totalSteps={Object.keys(stepsComponents).length}
            currentStep={currentStep}
            addData={data?.[`screen_${currentStep}_add`]}
            complianceText={data?.[`screen_${currentStep}_cta_variant_compliance_text`]}
            availibility={availibility}
          />
        )}
      </FormProvider>
    </main>
  )
}
